import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Paper,
  Grid,
  TextField,
  MenuItem,
  Button,
  Typography,
  Switch, 
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import DashboardViewService from '../../services/dashboardview.service';
import AuditTrailViewService from '../../services/audittrailview.service.js';
import ConfigurationViewService from '../../services/configurationview.service.js';

const booleanOptions = [
  { value: true, label: 'True' },
  { value: false, label: 'False' },
];

const statusOptions = [
  { value: 'Enabled', label: 'Enabled' },
  { value: 'Disabled', label: 'Disabled' },
]

const modeOptions = [
  { value: "Publish", label: 'Publish' },
  { value: "Subscribe", label: 'Subscribe' },
];

const device_typeOptions = [
  { value: "Radix-EFM", label: 'Radix-EFM' },
  { value: "Radix-Controller", label: 'Radix-Controller' },
  { value: "Other", label: 'Other' },
];

const gatewaytypeOptions = [
  { value: "Radix-gprs", label: 'Radix-gprs' },
  { value: "Radix-lora", label: 'Radix-lora' },
  { value: "Radix-wan/lan", label: 'Radix-wan/lan' },
];


function hasBlankOrNullValues(obj) {
  for (const key in obj) {
    const value = obj[key];

    if (value === null || value === '') {
      return true; // Found a blank or null value
    }

    if (typeof value === 'string') {
      // Try parse JSON string to object and check recursively
      try {
        const parsed = JSON.parse(value);
        if (typeof parsed === 'object' && parsed !== null) {
          if (hasBlankOrNullValues(parsed)) {
            return true;
          }
        }
      } catch {
        // Not a JSON string, ignore
      }
    } else if (typeof value === 'object' && value !== null) {
      // Normal object recursion
      if (hasBlankOrNullValues(value)) {
        return true;
      }
    }
  }

  return false; // No blank or null values found
}


// Check for the values are within min max range or not
function isWithinMinMaxRanges(data, ranges, exclude) {
  for (const key in data) {
    // Skip checking for values in the exclude array
    if (exclude.includes(key)) {
      continue;
    }

    if (key in ranges) {
      const { min, max } = ranges[key];
      if (data[key] < min || data[key] > max) {
        return false; // Value is outside the specified range
      }
    }
  }
  return true; // All values are within their respective ranges
}

function SaveChangesDialog(props) {
  const [open, setOpen] = useState(true);

  const handleClickOpen = () => {

    setOpen(true);
    
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSuccessClose = () => {
    setOpenSuccessDialog(false);
    props.success(true);
  };

  const handleFildClose = () => {
    setOpenFaildialog(false);
  };
  

  const [message, setMessage] = useState();

  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openFaildialog, setOpenFaildialog] = useState(false);

  const [saveData, setSaveData] = useState(false);
  const handleClickSaveChanges = () => { 
     setSaveData(true);
     };

  const [topicNameList, setTopicNameList] = useState([]);   

  //  Add new row to DashboardConfig collection 
  useEffect(() =>{
    async function saveRowData()  {
    try {

      let dashboardName = "DashboardConfig"
      let data = props.rowData;

      // Blank value check for the  one of the form field
      if (hasBlankOrNullValues(data)) {
        setOpenFaildialog(true);
        setMessage("One of the field is blank inside the form, please correct it.");
        setSaveData(false);
        setOpen(false); // Close "Save changes" window

      } else {
        //console.log(data);
        //const response = true;

        const response = await DashboardViewService.insertMultipleRow(dashboardName, data);  // create new record if id is not present in array data ie existing data
        if(response){
          setOpenSuccessDialog(true);
          setMessage("Record Added Successfully");
          setSaveData(false);
          setOpen(false); // Close "Save changes" window
  
        }

      }


    } catch (error) {
      setOpenFaildialog(true);
      setMessage("Error While Adding Record, Please verify all parameters entered in form");
      setOpen(false); // Close "Save changes" window
      console.log(error);


    }
  };
  if(saveData){
    saveRowData();
    setSaveData(false);
  };


  }, [saveData]);
  

  return (
    
    <div>
      
      
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>SAVE CHANGES</DialogTitle>
        <Box sx={{width: 400 }}>
        <DialogContent dividers>
          <DialogContentText>
            Are you sure to update dashboardconfig data.
          </DialogContentText>
          
        </DialogContent>
        </Box>
        <DialogActions>
          <Button onClick={handleClickSaveChanges}>Save</Button>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Success dialog after upgradtion of teh user info. */}
      <Dialog
        open={openSuccessDialog}
        onClose={handleSuccessClose}
       
      >
        <DialogTitle > success.. </DialogTitle>
        <DialogContent>
          <DialogContentText>
            { message } 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSuccessClose}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Save Changes Failed dialog /Wrong Password */}
      <Dialog
        open={openFaildialog}
        onClose={handleFildClose}
       
      >
        <DialogTitle > Failed.. </DialogTitle>
        <DialogContent>
          <DialogContentText>
            { message } 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFildClose}>Close</Button>
        </DialogActions>
      </Dialog>


    </div>
  );
}

export default function DashboardConfig (){
  const { user } = useSelector((state) => state.auth);
  const widgetName = useSelector((state) => state.splitbutton12WidgetName.widgetName);
  const widgetDescription = useSelector((state) => state.splitButton12WidgetDescription.widgetDescription);

  const [eventDescription, setEventDescription] = useState("--");
  const [auditTrailRemark, setAuditTrailRemark] = useState("--");
  const [rowData, setRowData] = React.useState([]); // Specific Row Data
  // parameter list for audit trail log


  const[deleteDialog, setDeleteDialog] = React.useState(false); // Delete Dialog bit
  const noButtonRef = React.useRef(null); 
  const[deleteData, setDeleteData] = React.useState(false); //Delete row bit
  const [snackbar, setSnackbar] = React.useState(null); // if delete Success then set to success otherwise will set to fail

  const handleCloseSnackbar = () => setSnackbar(null);

  const [addRecordForm, setAddRecordForm] = React.useState(false)
  const [editRecordForm, setEditRecordForm] = React.useState(false)
  const [editRowData, setEditRowData] = React.useState(false)

  const[remarkDialog, setRemarkDialog] = React.useState(false); // Remark Dialog bit
  const [openRemarkBlnkMsg, setOpenRemarkBlnkMsg] = useState(false);
  const [password, setPassword] = useState('');
  const[pwdinterlock, setPwdInterlock] = useState("Disabled");


  // Get AuditTrail Configuration data for Remark field, either it is enabled or disabled
  useEffect(() =>{
    async function auditTrailConfigData()  {
    try {

      let dashboardName = 'AuditTrailConfig';
      let columnName = 'EventName';
      let columnValue = 'Delete Dashboard';
      let response = await AuditTrailViewService.getColumnData(dashboardName, columnName, columnValue);

      //console.log(response.data[0].EnableRemark);
      if(response.data.length > 0){
        setRowData({...rowData, EventStatus: response.data[0].EnableEvent, PWDInterlock: response.data[0].EnablePwdInterlock, RemarkStatus: response.data[0].EnableRemark});
        setPwdInterlock(response.data[0].EnablePwdInterlock);
        setEventDescription(response.data[0].DefaultEventDescription);
        // If remark field is disabled then set default remark vlaue to currrent Remark value
        if(response.data[0].EnableRemark === "Disabled"){
          setAuditTrailRemark(response.data[0].DefaultEventRemark);
        }
        
      }

    } catch (error) {
      console.log(error);

    }
  }

  auditTrailConfigData();

  }, []);

  const [fetchData, setFetchData] = useState(true);
  const [data, setData] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editedJson, setEditedJson] = useState('');
  const [error, setError] = useState('');
  const [saveData, setSaveData] = useState(false);
  const [close, setClose] = useState(true);

  // Load data from backend
  
  useEffect(() =>{
    async function getColumnData()  {
      try {
        setData([]);
    
        let dashboardName = "DashboardConfig";
        let columnName = "DashboardName";
        let columnValue = widgetName;
        const response = await DashboardViewService.getColumnData(dashboardName, columnName, columnValue );
        //console.log(response.data);
        if(response.data.length > 0){
            setData(response.data);
            //console.log(response.data)
            
        }
        
        
      } catch (error) {
        console.log(error);
    
      }
    }
    getColumnData();
    setFetchData(false);
      
  
  }, [widgetName]);

  const handleEdit = (index) => {
    setEditIndex(index);
    setEditedJson(JSON.stringify(data[index], null, 2)); // Preload editable JSON string
    setError('');
  };

  const handleSave = () => {
    try {
      const parsed = JSON.parse(editedJson); // Try parsing to validate JSON
      const updatedData = [...data];
      updatedData[editIndex] = parsed;
      setData(updatedData);
      //console.log(updatedData)
      setEditIndex(null);
      setSaveData(true);
      setClose(false);

    } catch (err) {
      setError(`JSON Parse Error: ${err.message}`);
    }
  };


  const handleClose = () => {
    setClose(true);
    setSaveData(false);
    setFetchData(true);
  }

  return (
    <div style={{ padding: 16 }}>
  <Paper
    elevation={3}
    sx={{
      p: 2,
      width: '100%',
      maxWidth: '900px', // limit width of the container
      margin: 'auto',
      position: 'relative',
      overflow: 'hidden'
    }}
  >
    <Box sx={{ maxHeight: '75vh', overflowY: 'auto' }}>
      <Typography
        variant="h6"
        sx={{ textAlign: 'center', marginBottom: 2 }}
      >
        Dashboard Configuration - {widgetName}
      </Typography>

      <Divider />

      {/* Dashboard Configuration */}
      <Box sx={{ mt: 2 }}>
        {data.map((item, index) => (
          <Box
            key={item._id}
            sx={{
              mb: 2,
              border: '1px solid #ccc',
              borderRadius: 1,
              p: 2,
              backgroundColor: '#fafafa',
              overflowWrap: 'anywhere'
            }}
          >
            {editIndex === index ? (
              <>
                <textarea
                  rows={10}
                  style={{
                    width: '100%',
                    fontFamily: 'monospace',
                    boxSizing: 'border-box'
                  }}
                  value={editedJson}
                  onChange={(e) => setEditedJson(e.target.value)}
                />
                {error && (
                  <Typography color="error" sx={{ mt: 1 }}>
                    {error}
                  </Typography>
                )}
                <button onClick={handleSave}>Save</button>
              </>
            ) : (
              <>
                <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {JSON.stringify(item, null, 2)}
                </pre>
                <button onClick={() => handleEdit(index)}>Edit</button>
              </>
            )}
          </Box>
        ))}
      </Box>
    </Box>

    <Dialog

        open={saveData}
        onClose={handleClose}
        //maxWidth="md"
        //fullWidth
        scroll="paper"
        sx={{ justifyContent: 'flex-end' }}
      >
        
      <SaveChangesDialog
        rowData = {data}
        success = {handleClose}
        saveData = {saveData}
      />
    </Dialog>
  </Paper>
</div>

  );
};

